export const CREATE_CASE_FROM_ALERT = 'CREATE_CASE_FROM_ALERT';
export const CREATE_CASE_FROM_ALERT_SUCCESS = 'CREATE_CASE_FROM_ALERT_SUCCESS';
export const CREATE_CASE_FROM_ALERT_FAIL = 'CREATE_CASE_FROM_ALERT_FAIL';
export const CLOSE_CASE_FROM_ALERT_INFO_MODAL =
  'CLOSE_CASE_FROM_ALERT_INFO_MODAL';
export const SELECT_ALERTS_FOR_ACTIONS = 'SELECT_ALERTS_FOR_ACTIONS';
export const RESET_CONVERT_ALERTS_TO_CASE = 'RESET_CONVERT_ALERTS_TO_CASE';

export const createCaseFromAlert = (alertIds, departmentId) => ({
  type: CREATE_CASE_FROM_ALERT,
  payload: { alertIds, departmentId }
});

// FIN-12949/FIN-13021 — Create Case is now a PARTIAL operation: the BE cases what it can and
// reports the rest. `skippedAlreadyCased` were already in a case, `skippedUnknown` resolve to no
// alert row (hydrated run-instance ids). Both default to [] so the generic CM alert-list Convert
// path, which ignores them, is unaffected.
export const createCaseFromAlertSuccess = ({
  caseId,
  skippedAlreadyCased = [],
  skippedUnknown = []
}) => ({
  type: CREATE_CASE_FROM_ALERT_SUCCESS,
  payload: { caseId, skippedAlreadyCased, skippedUnknown }
});

export const createCaseFromAlertFail = ({ message }) => ({
  type: CREATE_CASE_FROM_ALERT_FAIL,
  payload: message
});

export const closeCaseFromAlertInfoModal = () => ({
  type: CLOSE_CASE_FROM_ALERT_INFO_MODAL
});

export const resetConvertAlertsToCase = () => ({
  type: RESET_CONVERT_ALERTS_TO_CASE
});

export const selectAlertsForActions = (selectedIds) => ({
  type: SELECT_ALERTS_FOR_ACTIONS,
  payload: selectedIds
});
